import Vue from 'vue'
import VueTheMask, { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'
import PageBase from './components/PageBase'
import CloseIcon from './components/CloseIcon'
import AppCard from './components/AppCard'
import AppDialog from './components/AppDialog'
import AppButton from './components/AppButton'
import AppPagination from './components/AppPagination'
import AppChip from './components/AppChip'
import AppPage from './components/AppPage'
import AppContent from './components/AppContent'
import AppToolbar from './components/AppToolbar'
import AppTable from './components/AppTable'
import AppActionsMenu from './components/AppActionsMenu'
import AppMetricCard from './components/AppMetricCard.vue'
import AppAlert from './components/AppAlert.vue'
import AppTextField from './components/AppTextField.vue'
import AppAutocomplete from './components/AppAutocomplete.vue'
import AppSelect from './components/AppSelect.vue'
import AppSkeleton from './components/AppSkeleton'
import AppFileInput from './components/AppFileInput.vue'
import AppForm from './components/AppForm.vue'
import AppTextarea from './components/AppTextarea.vue'
import AppCopyableText from './components/AppCopyableText.vue'
import AppFloatInput from './components/AppFloatInput.vue'
import '@/core/filters'
import './core.scss'

Vue.directive(mask)

Vue.component('page-base', PageBase)
Vue.component('close-icon', CloseIcon)
Vue.component('AppCard', AppCard)
Vue.component('AppDialog', AppDialog)
Vue.component('AppButton', AppButton)
Vue.component('AppPagination', AppPagination)
Vue.component('AppChip', AppChip)
Vue.component('AppPage', AppPage)
Vue.component('AppContent', AppContent)
Vue.component('AppToolbar', AppToolbar)
Vue.component('AppTable', AppTable)
Vue.component('AppActionsMenu', AppActionsMenu)
Vue.component('AppMetricCard', AppMetricCard)
Vue.component('AppAlert', AppAlert)
Vue.component('AppTextField', AppTextField)
Vue.component('AppAutocomplete', AppAutocomplete)
Vue.component('AppSelect', AppSelect)
Vue.component('AppSkeleton', AppSkeleton)
Vue.component('AppFileInput', AppFileInput)
Vue.component('AppForm', AppForm)
Vue.component('AppTextarea', AppTextarea)
Vue.component('AppCopyableText', AppCopyableText)
Vue.component('AppFloatInput', AppFloatInput)
Vue.component('AppMarkdownViewer', () => import('./components/AppMarkdownViewer'))
Vue.component('AppMarkdownEditor', () => import('./components/AppMarkdownEditor'))
Vue.component('AppEmojiPicker', () => import('./components/AppEmojiPicker'))

Vue.use(VueTheMask)

Vue.mixin({
  methods: {
    ...mapActions('dashboard', [
      'showLoading',
      'hideLoading',
      'showErrorOnSnackbar',
      'showSuccessOnSnackbar',
      'showInfoOnSnackbar',
      'showWarningOnSnackbar',
      'hideSnackbar',
      'hideAllMessages',
    ]),
  },
})
